module.exports = __webpack_public_path__ + "img/btn-story.7cc6c0c0.svg";